<template>
    <div class="callback-page">
        <div class="center-box">
            <div class="centered-div">
                <div v-if="error">
                    <h4>❌ เกิดข้อผิดพลาด</h4>
                    <p class="text-danger">{{ error }}</p>
                    <div v-if="debugInfo" class="mt-3 text-left">
                        <h6>Debug Info:</h6>
                        <pre class="debug-box">{{ debugInfo }}</pre>
                    </div>
                    <router-link to="/login" class="btn btn-primary mt-3">กลับหน้า Login</router-link>
                </div>
                <div v-else>
                    <img src="images/loading_ok4.gif" width="300" alt="">
                    <p>กำลังเข้าสู่ระบบ...</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
    name: "ProviderCallback",
    data() {
        return {
            error: "",
            debugInfo: "",
        };
    },
    async created() {
        // รับ JWT จาก query parameter ?t={jwt}
        const providerJwt = this.$route.query.t;
        if (!providerJwt) {
            this.error = "ไม่พบ JWT ใน URL (parameter ?t=...)";
            return;
        }

        try {
            // 1. Decode JWT จาก Provider ID
            const payload = JSON.parse(atob(providerJwt.split(".")[1]));
            console.log("Provider ID payload:", payload);

            const cid = payload.profile.id_card;
            const organizations = payload.profile.organization || [];

            // 2. ดึง hosCode จาก localStorage (เลือกจาก dropdown ตอน login)
            const hcode = localStorage.getItem("provider_hosCode");
            if (!hcode) {
                this.error = "ไม่พบ hosCode — กรุณาเลือกโรงพยาบาลก่อน login";
                return;
            }

            // 3. เทียบ hcode ที่เลือกกับ hcode ใน JWT (คนหนึ่งอาจมีหลายที่ทำงาน)
            // hcode 00037 = admin สามารถเข้าได้ทุกโรงพยาบาล
            const isAdmin = organizations.some(org => org.hcode === "00037");
            const matchedOrg = organizations.find(org => org.hcode === hcode);

            if (!isAdmin && !matchedOrg) {
                const allowedList = organizations
                    .map(org => `${org.hcode} (${org.position})`)
                    .join(", ");
                this.error = `โรงพยาบาลที่เลือก (${hcode}) ไม่ตรงกับสิทธิของท่าน — สิทธิที่มี: ${allowedList}`;
                return;
            }
            console.log(isAdmin ? "Admin access granted" : "Matched organization:", matchedOrg);

            // 3. ดึง IP ของ client
            let clientIp = "";
            try {
                const clientRes = await axios.get(
                    `${process.env.VUE_APP_URL_AUTH}/client/`
                );
                // API อาจตอบ IP หลายตัว เช่น "127.0.0.1,61.19.145.131, 192.168.100.55"
                // ต้องเอาแค่ IP แรกที่ไม่ใช่ 127.0.0.1
                const rawIp = clientRes.data.client_ip || "";
                const ipList = rawIp.split(/[,\s]+/).filter(ip => ip && ip !== "127.0.0.1");
                clientIp = ipList.length > 0 ? ipList[0] : "127.0.0.1";
                console.log("client IP (parsed):", clientIp);
            } catch (e) {
                console.warn("ไม่สามารถดึง client IP ได้:", e);
            }

            // 4. เรียก createToken API เพื่อสร้าง access_token ของระบบ
            const url =
                process.env.VUE_APP_URL_AUTH +
                `/viewer/?exp=${process.env.VUE_APP_EXPIRES_IN}`;

            const requestBody = {
                account_token: process.env.VUE_APP_ACCOUNT_TOKEN,
                hosCode: hcode,
                cid: cid,
                patientCid: cid,
                patientHosCode: hcode,
                ip: clientIp,
            };

            console.log("createToken URL:", url);
            console.log("createToken request body:", requestBody);

            const response = await axios.post(url, requestBody, {
                headers: { "Content-Type": "application/json" },
            });

            console.log("createToken status:", response.status);
            console.log("createToken response:", response.data);

            if (response.status === 200 && response.data.access_token) {
                // 5. เก็บ token ใน localStorage แล้วลบ provider_hosCode
                localStorage.setItem("token", response.data.access_token);
                localStorage.removeItem("provider_hosCode");

                // 6. Redirect ไป dashboard
                this.$router.push("/dashboard");

                Swal.mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 6000,
                    timerProgressBar: true,
                }).fire({
                    icon: "success",
                    title: "เข้าสู่ระบบด้วย Provider ID สำเร็จ!",
                });
            } else {
                this.debugInfo = JSON.stringify(
                    { status: response.status, data: response.data, requestBody },
                    null,
                    2
                );
                this.error =
                    "ไม่สามารถสร้าง Token ได้ — กรุณาตรวจสอบสิทธิการเข้าใช้งาน";
            }
        } catch (e) {
            this.debugInfo = JSON.stringify(
                {
                    message: e.message,
                    status: e.response?.status,
                    data: e.response?.data,
                },
                null,
                2
            );
            this.error = "เกิดข้อผิดพลาดในการประมวลผล: " + e.message;
            console.error(e);
        }
    },
};
</script>

<style scoped>
.callback-page {
    min-height: 100vh;
    background-color: #f4f6f9;
}

.center-box {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 2rem;
}

.centered-div {
    max-width: 600px;
    width: 100%;
    text-align: center;
    background: white;
    padding: 2rem;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.debug-box {
    background: #f8f9fa;
    padding: 1rem;
    border-radius: 8px;
    font-size: 0.8rem;
    overflow-x: auto;
    text-align: left;
    max-height: 300px;
    overflow-y: auto;
}
</style>
